module.exports = __webpack_public_path__ + "static/media/discount-timer-unchecked.d771f14a.svg";